export default __webpack_public_path__ + "static/media/EM0340.34I-22004_-25385_0.9f944f03.jpg";